import { render, staticRenderFns } from "./TheTicketsSystem.vue?vue&type=template&id=b27be31a&"
import script from "./TheTicketsSystem.vue?vue&type=script&lang=js&"
export * from "./TheTicketsSystem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports